import {message} from 'antd'
import {deleteBasket} from "../../../../services/api/3dApi"

export default async function (orderId) {
    try {
        const {data: response} = await deleteBasket(orderId)

        const {success, error} = response

        if (!success) {
            throw new Error(error)
        }

        message.success('Xóa thành công')
    } catch (e) {
        message.error(e.message, 3)
    }
}
